import React from "react";

const Games = () => {
  return <div>Games</div>;
};

export default Games;
